import { Select } from 'antd';
import PropTypes from '../../utils/propTypes';
import styles from './index.module.scss';

const { select, popup, white } = styles;

const AntdSelect = ({ size, theme, ...props }) => {
  return (
    <Select
      className={`${select} ${theme === 'white' ? white : ''}`}
      size={size === 'xLarge' ? 'large' : size}
      suffixIcon={
        <i
          className={`fas ${
            props.loading ? 'fa-spinner fa-spin' : 'fa-chevron-down'
          }`}
        />
      }
      popupClassName={popup}
      {...props}
      value={props.loading ? '' : props.value}
    />
  );
};

AntdSelect.propTypes = {
  size: PropTypes.oneOf(['large', 'small', 'middle', 'xLarge']),
  theme: PropTypes.oneOf(['white', 'default']),
  loading: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

AntdSelect.defaultProps = {
  size: 'middle',
  theme: 'default',
  loading: false,
  value: undefined,
};

export default AntdSelect;
